import React from 'react';
import { Container } from 'reactstrap';
import Footer from './Footer';
import Header from './Header';
import '../styles/layout.css';

export default props => (
  <div>
    <Header />
    <Container id="main">
      {props.children}
    </Container>
    <Footer text={"© 2023 GASAG AG"} version={"1"} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Layout.js